"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingFilterButton = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.RankingFilterButton = function (_a) {
    var isActive = _a.isActive, onClick = _a.onClick, title = _a.title, className = _a.className;
    var buttonClassName = classnames_1.default("gd-button", "gd-button-secondary", "gd-button-small", "button-dropdown", "gd-icon-right", { "gd-icon-navigateup": isActive, "gd-icon-navigatedown": !isActive }, "s-rf-dropdown-button", className);
    return (react_1.default.createElement("button", { className: buttonClassName, onClick: onClick }, title));
};
//# sourceMappingURL=RankingFilterButton.js.map